import { render, staticRenderFns } from "./SignupPackagesGroup.vue?vue&type=template&id=99878e4c"
import script from "./SignupPackagesGroup.vue?vue&type=script&lang=js"
export * from "./SignupPackagesGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports